// import node module libraries
import { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Image, Navbar, Nav, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// import custom components
import PricingMenu from 'layouts/marketing/navbars/PricingMenu';
import DarkLightMode from 'layouts/DarkLightMode';

// import media files
import Logo from 'assets/images/brand/logo/logo.svg';

// Import authentication components
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

// import data files
import NavbarDefaultRoutes from 'routes/marketing/NavbarDefaultRoutes';

const NavbarHaeppyapp = props => {
	const { t } = useTranslation(); // useTranslation-Hook
	const { transparent, center } = props;
	const [expandedMenu, setExpandedMenu] = useState(false);
	const auth = useAuthUser();
	const isAuthenticated = useIsAuthenticated()

	return (
		<Fragment>
			<Navbar
				onToggle={(collapsed) => setExpandedMenu(collapsed)}
				expanded={expandedMenu}
				expand="lg"
				className={`navbar navbar-default shadow-none ${transparent ? 'navbar-transparent' : ''}`}
			>
				<Container className="px-0">
					<Navbar.Brand as={Link} to="/">
						<Image src={Logo} width={200} alt="haeppy.app Logo" className="logo" />
					</Navbar.Brand>
					<DarkLightMode className="d-flex align-items-center" />
					<Navbar.Toggle aria-controls="basic-navbar-nav">
						<span className="icon-bar top-bar mt-0"></span>
						<span className="icon-bar middle-bar"></span>
						<span className="icon-bar bottom-bar"></span>
					</Navbar.Toggle>
					<Navbar.Collapse id="basic-navbar-nav">
						<Nav>
							<PricingMenu />
						</Nav>
						<Nav className={`${center ? 'd-flex align-items-center order-lg-3 flex-row' : 'navbar-nav navbar-right-wrap ms-auto d-flex'}`} >
							<div className={`my-3 mt-lg-0`}>
								{!isAuthenticated ? (
									<>
										<Nav.Link
											href="/authentication/sign-in"
											target=""
											bsPrefix="btn"
											className="btn btn-outline-primary mx-2 mt-2"
										>
											{t('Sign-in')}
										</Nav.Link>
										<Nav.Link
											href="/authentication/sign-up"
											target="_blank"
											bsPrefix="btn"
											className="btn btn-primary mt-2"
										>
											{t('Start for free')} <i className="fe fe-arrow-up-right"></i>
										</Nav.Link>
									</>
								) : (
									<>
										<Nav.Link
											href="/authentication/sign-up"
											target="_blank"
											bsPrefix="btn"
											className="btn btn-light mt-2"
											disabled
										>
											👋 Hey {auth.first_name}, {t('this way')}
										</Nav.Link>
										<Nav.Link
											href="/dashboard/overview"
											target=""
											bsPrefix="btn"
											className="btn btn-primary mx-0 mt-2"
										>
											{t('to Dashboard')} <i className="fe fe-arrow-up-right"></i>
										</Nav.Link>
									</>
								)}
							</div>
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</Fragment>
	);
};

// Specifies the default values for props
NavbarHaeppyapp.defaultProps = {
	transparent: true
};

// Typechecking With PropTypes
NavbarHaeppyapp.propTypes = {
	transparent: PropTypes.bool
};

export default NavbarHaeppyapp;